<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="100"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('Status')"
          ><!-- 状态 -->
          <Select v-model="formItem.status" clearable>
            <Option
              v-for="item in AchUpdateStatus"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot2"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin:20px 0"
      ref="table"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="toPage(row, index)"
        ></Button>
      </template>
    </Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <Button
        type="primary"
        style="margin-top:15px"
        v-if="isManager == '1'"
        @click="linkPage"
        ><!-- 新增 -->{{ $t("Add") }}</Button
      >
    </div>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  components: { FormComponent },
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      formItem: {},
      searchItem: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      item: {},
      isManager: "",
      AchUpdateStatus: [],
      ManagementLevel:[]
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 70,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "departmentCode" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_English") /* 英语职位 */,
          key: "enPosition",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnitCode" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Start_Date") /* 业务单元 */,
          key: "startDate",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("End_Date") /* 业务单元 */,
          key: "endDate",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupUserName" : "dirSupUserEName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
    // this.getData(JSON.stringify(this.$refs.FormComponent.formItem))
    // this.getListData()
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.AchUpdateStatus = res.AchUpdateStatus;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.functionList = res.functionList;
          this.ManagementLevel = res.ManagementLevel;

        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        // serialnumber:JSON.parse(sessionStorage.getItem('userInfo')).serialnumber,
        levemNum: 1,
        ...this.searchItem,
        ...this.pageInfo
      };
      this.loading = true;
      axios
        .post("/achUpdatePlan/selectAchUpdatePlanReportInfo", obj)
        .then(res => {
          if (res) {
            this.data = res.achUpdateInfoList;
            this.total = parseInt(res.pageInfo.total);
            this.item = res;
            this.isManager = res.isManager;
          }
          this.$refs.FormComponent.prevent = false;
          this.loading = false;
        });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },

    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    toPage(row, index) {
      // this.$router.push({
      //   path: "/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27",
      //   query: { isDirSup: row.isDirSup, id: row.id, item: JSON.stringify(row) }
      // });
      const href =
        "/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27/?isDirSup=" +
        row.isDirSup +
        "&id=" +
        row.id +
        "&item=" +
        JSON.stringify(row);
      window.open(href, "_blank");
    },
    linkPage() {
      // this.$router.push({
      //   path: "/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27",
      //   query: { isDirSup: "1" }
      // });
      let obj = {
        code: "ESS"
      };
      const href =
        "/F4861F9E4EB7B7DE62E634E5A81A4043/A3FFBEBFDB713E27/?isDirSup=1&item=" +
        JSON.stringify(obj);
      window.open(href, "_blank");
    },
    handleReset() {
      this.formItem = {};
      this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PerformanceCoaching.vue